export const ACCOUNT_GROUPS_LIST_URL: string = 'account-group/list';

export const CREATE_ACCOUNT_GROUP_URL: string = 'account-group/';
export const GET_ACCOUNT_GROUP_URL: string = 'account-group/{accountGroupId}';
